import { Box } from "@chakra-ui/react";
import { palette } from "./theme";

export const DataTable = ({
  headers,
  rows,
  columnWidths,
  onRowClick,
}: {
  headers: React.ReactNode[];
  rows: React.ReactNode[][];
  columnWidths?: (string | undefined)[];
  onRowClick?: (rowIndex: number) => void;
}): JSX.Element => (
  <Box as="table" width="100%" borderCollapse="collapse" tableLayout="fixed">
    <Box as="thead">
      <Box as="tr">
        {headers.map((header, headerIndex) => (
          <Box
            as="th"
            key={headerIndex}
            width={columnWidths?.[headerIndex]}
            textAlign="left"
            color={palette.muted}
            fontSize="11px"
            fontWeight="700"
            p="8px 6px"
            borderBottom={`1px solid ${palette.border}`}
          >
            {header}
          </Box>
        ))}
      </Box>
    </Box>
    <Box as="tbody">
      {rows.map((row, rowIndex) => (
        <Box
          as="tr"
          key={rowIndex}
          {...(onRowClick && {
            onClick: () => onRowClick(rowIndex),
            cursor: "pointer",
            tabIndex: 0,
            role: "button",
            onKeyDown: (event: React.KeyboardEvent) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                onRowClick(rowIndex);
              }
            },
            _hover: { bg: palette.soft },
          })}
        >
          {row.map((cell, cellIndex) => (
            <Box
              as="td"
              key={`${rowIndex}-${cellIndex}`}
              p="11px 6px"
              borderBottom={`1px solid ${palette.border}`}
              fontSize="12px"
              color={palette.label}
              overflow="hidden"
              textOverflow="ellipsis"
            >
              {cell}
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  </Box>
);
